import { useState, useEffect } from 'react';
import axios from 'axios';
import { useDebounce } from './Debounce';
const serializeFilters = (filters) => {
    if (typeof filters === 'string') return filters; // fallback if string
    return Object.entries(filters)
        .filter(([_, value]) => value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
};


const usePaginatedData = ({
    url,
    localKeys,
    enableSearch = true,
    enableFilter = false,
    queryParams = {},
}) => {
    const [meta, setMeta] = useState({});

    console.log('usePaginatedData called with URL:', queryParams, url);
    const [data, setData] = useState({});
    const [prevData, setPrevData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [inputValue, setInputValue] = useState(() => {
        return localStorage.getItem(localKeys.search) || '';
    });

    let initialFilter = {};
    try {
        const saved = localStorage.getItem(localKeys.filter);
        initialFilter = saved ? JSON.parse(saved) : {};
    } catch (e) {
        console.warn('Invalid filter format in localStorage, resetting...');
        localStorage.removeItem('filter');
        initialFilter = {};
    }

    const [filterValue, setFilterValue] = useState(initialFilter);

    // const debouncedSearchValue = useDebounce(inputValue.toLowerCase(), 500);

    const debouncedSearchValue = useDebounce(inputValue.trim().toLowerCase(), 500);


    const [page, setPage] = useState(() => {
        return {
            pageno: Number(localStorage.getItem(localKeys.page)) || 1,
            totalPage: Number(localStorage.getItem(localKeys.totalPage)) || 0,
            totalData: Number(localStorage.getItem(localKeys.totalData)) || 0,
        };
    });
    const fetchData = async (pageno, search = '', filter = {}) => {
        const cacheKey = `${pageno}-${search}-${serializeFilters(filter)}`;
        const cached = data[cacheKey];
        console.log('Fetching data with params:', { pageno, search, filter, cacheKey, cached });

        if (cached) {
            setPrevData(cached);
            const metaInfo = meta[cacheKey];
            if (metaInfo) {
                setPage(prev => ({
                    ...prev,
                    pageno,
                    totalPage: metaInfo.totalPage,
                    totalData: metaInfo.totalData,
                }));
            }
            return;
        }
        setIsLoading(true);
        try {
            const params = {
                page: pageno,
                limit: 20,
                ...(enableSearch && { query: search }),
                ...(enableFilter && filter),
                ...queryParams,
            };
            console.log(params)
            const res = await axios.get(url, {
                withCredentials: true,
                params,
            });
            console.log('API response:', res.data);



            if (res.status === 200) {
                const list = res.data?.dataList || [];
                const totalData = res.data?.total || 0;
                const totalPage = Math.ceil(totalData / 20);

                const isInitialFetch = pageno === 1 && search.trim() === '' && Object.values(filter).every(v => v === '');

                if (isInitialFetch) {
                    // Cache total only for initial unfiltered fetch
                    localStorage.setItem(localKeys.totalPage, totalPage);
                    localStorage.setItem(localKeys.totalData, totalData);
                    localStorage.setItem(localKeys.page, pageno);
                }

                setData(prev => ({ ...prev, [cacheKey]: list }));
                setMeta(prev => ({ ...prev, [cacheKey]: { totalData, totalPage } }));

                setPrevData(list);
                setMessage(res.data.message || null);
                setPage({
                    pageno,
                    totalPage,
                    totalData,
                });
                localStorage.setItem(localKeys.page, pageno);
            }
        } catch (err) {
            console.error('Error fetching data:', err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page.pageno, debouncedSearchValue, filterValue);
    }, [page.pageno, debouncedSearchValue, JSON.stringify(filterValue)]);

    const handleSearch = (e) => {
        const value = e.target.value;
        console.log('Search input changed:=============', localKeys.search, value, '=======================================================');
        setInputValue(value);
        localStorage.setItem(localKeys.search, value);
        setPage(prev => ({ ...prev, pageno: 1 }));
    };

    // const handleFilter = (value) => {
    //     setFilterValue(value);
    //     localStorage.setItem(localKeys.filter, value);
    //     setPage(prev => ({ ...prev, pageno: 1 }));
    // };
    const handleFilter = (name, value) => {
        setFilterValue(prev => {
            const isSameValueSelected = prev[name] === value;

            const newFilters = {
                ...prev,
                [name]: isSameValueSelected ? '' : value, // toggle or replace
            };

            localStorage.setItem(localKeys.filter, JSON.stringify(newFilters));
            setPage(prevPage => ({ ...prevPage, pageno: 1 }));
            return newFilters;
        });
    };


    return {
        data,
        prevData,
        page,
        setPage,
        isLoading,
        message,
        inputValue,
        setInputValue,
        filterValue,
        setFilterValue,
        handleSearch,
        handleFilter,
    };
};

export default usePaginatedData;
